<template>
  <div>
    <!-- 标题 -->
    <div class="ebs-title">
      <Breadcrumb>
        <BreadcrumbItem>{{ this.$route.query.accountTypeName }}</BreadcrumbItem>
        <BreadcrumbItem>{{ this.$route.query.accountName }}</BreadcrumbItem>
        <BreadcrumbItem>{{ this.$route.query.name }}</BreadcrumbItem>
        <BreadcrumbItem to="/monitor/elasticBlockStoreMonitor">{{
          $t("alarms.disk.disk")
        }}</BreadcrumbItem>
        <BreadcrumbItem>
          <a @click="ipAddress">{{ $t("alarms.common.monitoringSummary") }}</a>
        </BreadcrumbItem>
      </Breadcrumb>
    </div>
    <!-- 查询框 -->
    <div class="ebs-top">
      <Row :gutter="16">
        <Col span="6" v-show="isAzure">
          <Select v-model="timeType" filterable @on-change="changeTimeType(timeType)">
            <Option v-for="item in timeList" :value="item.id" :key="item.id">{{item.name}}</Option>
          </Select>
        </Col>
        <Col span="6" v-show="isAWS">
          <Select v-model="timeType" filterable @on-change="changeTimeTypeAWS(timeType)">
            <Option v-for="item in timeList" :value="item.id" :key="item.id">{{item.name}}</Option>
          </Select>
        </Col>
        <Col span="6" v-show="isAWS">
          <Select v-model="cycle" filterable @on-change="changeCycle()">
            <Option
              v-for="item in cycleList"
              :value="item.value"
              :key="item.name"
              >{{ item.name }}</Option
            >
          </Select>
        </Col>
        <Col span="6" v-show="isAliyun">
          <Select
            v-model="timeType"
            filterable
            @on-change="changeTimeTypeAliyun(timeType)"
          >
            <Option v-for="item in timeList" :value="item.id" :key="item.id">{{item.name}}</Option>
          </Select>
        </Col>
        <Col span="6" v-show="isGCP">
          <Select
            v-model="timeType"
            filterable
            @on-change="changeTimeTypeGCP(timeType)"
          >
            <Option v-for="item in timeList" :value="item.id" :key="item.id">{{item.name}}</Option>
          </Select>
        </Col>
        <Col span="6" v-show="isTencent">
          <Select
            v-model="timeType"
            filterable
            @on-change="changeTimeTypeTencent(timeType)"
          >
            <Option v-for="item in timeList" :value="item.id" :key="item.id">{{item.name}}</Option>
          </Select>
        </Col>
        <Col span="6" v-show="isTencent">
          <Select v-model="cycle" filterable @on-change="changeCycleTencent()">
            <Option
              v-for="item in cycleList"
              :value="item.value"
              :key="item.name"
              >{{ item.name }}</Option
            >
          </Select>
        </Col>
      </Row>
    </div>
    <!-- 折线图 -->
    <Row :gutter="16">
      <Col
        span="6"
        v-for="(item, index) in this.$route.query.accountTypeName == 'AWS'
          ? awsList
          : this.$route.query.accountTypeName == 'Aliyun'
          ? alyList
          : this.$route.query.accountTypeName == 'GCP'
          ? gcpList
          : this.$route.query.accountTypeName == 'Tencent Cloud'
          ? tencentList
          : azureList"
        :key="index"
      >
        <Card :padding="8">
          <p slot="title">{{ item.title }}</p>
          <a href="#" slot="extra" @click.prevent="changeFull(item)">
            <Icon type="ios-expand" size="18" />
          </a>
          <div
            :id="item.id"
            :ref="item.id"
            style="width: 100%; height: 240px"
          ></div>
        </Card>
      </Col>
    </Row>
    <!-- 放大弹出框 -->
    <Modal
      v-model="isShowModal"
      :mask-closable="false"
      :closable="false"
      width="65%"
    >
      <Row>
        <Col span="24">
          <h3>{{ lineTitle }}</h3>
          <div
            id="chart-part"
            ref="fullChart"
            style="width: 100%; height: 420px"
          ></div>
        </Col>
      </Row>
      <div slot="footer">
        <div>
          <Button @click="cancel">{{ $t("alarms.common.close") }}</Button>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import { setCookie, getCookie } from "../../../../utils/cookieUtil.js";

export default {
  name: "EBS",
  data() {
    return {
      // 放大功能
      lineTitle: "",
      isShowModal: false,
      // azure折线图
      azureList: [
        {
          id: "diskReadWriteIOPS",
          title: this.$t("alarms.disk.line.DiskReadAndWriteIOPSIOPS"),
        },
      ],
      // 阿里云折线图
      alyList: [
        {
          id: "diskReadIOPS",
          title: this.$t("alarms.disk.line.DiskReadIOPSIOPS"),
        },
        {
          id: "diskWriteIOPS",
          title: this.$t("alarms.disk.line.DiskWriteIOPSIOPS"),
        },
        {
          id: "diskSpaceUtilization",
          title: this.$t("alarms.disk.line.DiskSpaceUsage"),
        },
        {
          id: "spaceUsage",
          title: this.$t("alarms.disk.line.SpaceUsage"),
        },
        {
          id: "inodeUtilization",
          title: this.$t("alarms.disk.line.InodeUtilization"),
        },
        {
          id: "diskReadAndWriteBPS",
          title: this.$t("alarms.disk.line.DiskReadAndWriteBPS"),
        },
        {
          id: "diskReadAndWriteRequestCount",
          title: this.$t("alarms.disk.line.DiskReadAndWriteRequestCount"),
        },
      ],
      // aws折线图
      awsList: [
        {
          id: "volumeTotalReadWriteTimes",
          title: this.$t(
            "alarms.disk.line.TheTotalNumberOfSecondsSpentInReadAndWriteOperationsSeconds"
          ),
        },
        {
          id: "volumeReadWriteOps",
          title: this.$t("alarms.disk.line.ReadAndWriteThroughputOpss"),
        },
        {
          id: "volumeReadWriteBytes",
          title: this.$t("alarms.disk.line.ReadAndWriteBandwidthBytes"),
        },
        {
          id: "burstBalances",
          title: this.$t("alarms.disk.line.BurstBalancePercentage"),
        },
        {
          id: "volumeQueueLengths",
          title: this.$t("alarms.disk.line.AverageQueueLengthSeconds"),
        },
        {
          id: "volumeIdleTimes",
          title: this.$t("alarms.disk.line.PercentageOfIdleTimeSeconds"),
        },
      ],
      gcpList: [
        {
          id: "chartElementGcpDiskBytesUsed",
          title: this.$t("alarms.disk.line.gcpDiskBytesUsed" ),
        },
        {
          id: "chartElementGcpDiskIOTime",
          title: this.$t("alarms.disk.line.gcpDiskIOTime" ),
        },
        {
          id: "chartElementGcpDiskOperationCount",
          title: this.$t("alarms.disk.line.gcpDiskOperationCount" ),
        },
      ],
      isAWS: false,
      isAzure: false,
      isAliyun: false,
      isGCP: false,
      isTencent: false,
      // 腾讯云折线图
      tencentList: [
        {
          id: "tencentDiskReadIops",
          title: "磁盘读IOPS",
        },
        {
          id: "tencentDiskWriteIops",
          title: "磁盘写IOPS",
        },
      ],
      timeType: 0,
      timeList: [],
      cycle: 300,
      cycleList: [
        {
          name: this.$t("alarms.common.fiveMinutes"),
          value: 5 * 60,
        },
        {
          name: this.$t("alarms.common.fifteenMinutes"),
          value: 15 * 60,
        },
        {
          name: this.$t("alarms.common.oneHour"),
          value: 1 * 60 * 60,
        },
        {
          name: this.$t("alarms.common.sixHour"),
          value: 6 * 60 * 60,
        },
        {
          name: this.$t("alarms.common.oneDay"),
          value: 24 * 60 * 60,
        },
      ],
      // echarts实例
      chartDiskReadWriteIOPS: "",
      chartDiskReadIOPS: "",
      chartDiskWriteIOPS: "",
      chartDiskSpaceUtilization: "",
      chartVolumeTotalReadWriteTimes: "",
      chartVolumeReadWriteOps: "",
      chartVolumeReadWriteBytes: "",
      chartBurstBalances: "",
      chartVolumeQueueLengths: "",
      chartVolumeIdleTimes: "",
      chartSpaceUsage: "",
      chartInodeUtilization: "",
      chartDiskReadAndWriteBPS: "",
      chartDiskReadAndWriteRequestCount: "",
      diskReadWriteIOPSOption: {}, //azure
      diskReadIOPSOption: {},
      diskWriteIOPSOption: {},
      diskSpaceUtilizationOption: {},
      spaceUsageOption: {},
      inodeUtilizationOption: {},
      diskReadAndWriteBPSOption: {},
      diskReadAndWriteRequestCountOption: {}, //阿里云
      volumeTotalReadWriteTimesOption: {},
      volumeReadWriteOpsOption: {},
      volumeReadWriteBytesOption: {},
      burstBalancesOption: {},
      volumeQueueLengthsOption: {},
      volumeIdleTimesOption: {}, //aws
      // Aliyun数组
      diskReadIOPSAliyun: [],
      diskWriteIOPSAliyun: [],
      diskSpaceUtilizationAliyun: [],
      spaceUsageAliyun: [],
      inodeUtilizationAliyun: [],
      diskReadAndWriteBPSAliyun: [],
      diskReadBPS: [],
      diskWriteBPS: [],
      diskReadAndWriteRequestCountAliyun: [],
      diskReadRequestCount: [],
      diskWriteRequestCount: [],
      // Azure数组
      diskWriteIOPSAzure: [],
      diskReadIOPSAzure: [],
      xaxisData: [],
      // Aws数组
      diskReadOps: [],
      diskWriteOps: [],
      burstBalance: [],
      volumeIdleTime: [],
      volumeQueueLength: [],
      diskReadBytes: [],
      volumeTotalReadTime: [],
      volumeTotalWriteTime: [],
      diskWriteBytes: [],
      xaxisDataAWS: [],
      // GCP数组
      gcpDiskBytesUsed: [],
      gcpDiskIOTime: [],
      gcpDiskOperationCount: [],
      gcpDiskBytesUsedOption:{},
      gcpDiskIOTimeOption:{},
      gcpDiskOperationCountOption:{},
      gcpXaxisDataTimeLine:[],
      chartGcpDiskBytesUsed:"",
      chartGcpDiskIOTime:"",
      chartGcpDiskOperationCount:"",
    };
  },
  mounted: function () {
    if (this.$route.query.accountTypeName == "AWS") {
      this.isAWS = true;
      this.queryTimeHorizon();
      // 自适应不同屏幕尺寸
      const self = this;
      window.addEventListener("resize", function () {
        self.chartVolumeTotalReadWriteTimes.resize();
        self.chartVolumeReadWriteOps.resize();
        self.chartVolumeReadWriteBytes.resize();
        self.chartBurstBalances.resize();
        self.chartVolumeQueueLengths.resize();
        self.chartVolumeIdleTimes.resize();
      });
    } else if (this.$route.query.accountTypeName == "Azure") {
      this.isAzure = true;
      this.queryTimeHorizon();
      // 自适应不同屏幕尺寸
      const self = this;
      window.addEventListener("resize", function () {
        self.chartDiskReadWriteIOPS.resize();
      });
    } else if (this.$route.query.accountTypeName == "Aliyun") {
      this.isAliyun = true;
      this.queryTimeHorizon();
      // 自适应不同屏幕尺寸
      const self = this;
      window.addEventListener("resize", function () {
        self.chartDiskReadIOPS.resize();
        self.chartDiskWriteIOPS.resize();
        self.chartDiskSpaceUtilization.resize();
        self.chartSpaceUsage.resize();
        self.chartInodeUtilization.resize();
        self.chartDiskReadAndWriteBPS.resize();
        self.chartDiskReadAndWriteRequestCount.resize();
      });
    }else if (this.$route.query.accountTypeName == "GCP") {
      this.isGCP = true;
      this.queryTimeHorizon();
      // 自适应不同屏幕尺寸
      const self = this;
      window.addEventListener("resize", function () {
        self.gcpDiskBytesUsed.resize();
        self.gcpDiskIOTime.resize();
        self.gcpDiskOperationCount.resize();
      });
    } else if (this.$route.query.accountTypeName == "Tencent Cloud") {
      this.isTencent = true;
      this.queryTencentTimeHorizon();
    }
  },
  created() {
    if (this.$route.query.accountTypeName == "AWS") {
      this.isAWS = true;
      this.checkMonitorModuleIndex();
    } else if (this.$route.query.accountTypeName == "Azure") {
      this.isAzure = true;
      this.checkAzureCloudVMDiskStatistics();
    } else if (this.$route.query.accountTypeName == "Aliyun") {
      this.isAliyun = true;
      this.checkAliyunDiskStatistics();
    }else if (this.$route.query.accountTypeName == "GCP") {
      this.isGCP = true;
      this.checkGCPDiskStatistics();
    } else if (this.$route.query.accountTypeName == "Tencent Cloud") {
      this.isTencent = true;
    }
  },
  methods: {
    /******************放大********************************/
    changeFull: function (item) {
      this.isShowModal = true;
      this.lineTitle = item.title;
      this.$nextTick(() => {
        const chartFul = this.$refs.fullChart;
        if (chartFul) {
          const fullChart = this.$echarts.init(
            document.getElementById("chart-part")
          );
          fullChart.clear();
          // azure
          if (item.id == "diskReadWriteIOPS") {
            var optionFll = this.diskReadWriteIOPSOption;
          }
          // 阿里云
          else if (item.id == "diskReadIOPS") {
            var optionFll = this.diskReadIOPSOption;
          } else if (item.id == "diskWriteIOPS") {
            var optionFll = this.diskWriteIOPSOption;
          } else if (item.id == "diskSpaceUtilization") {
            var optionFll = this.diskSpaceUtilizationOption;
          } else if (item.id == "spaceUsage") {
            var optionFll = this.spaceUsageOption;
          } else if (item.id == "inodeUtilization") {
            var optionFll = this.inodeUtilizationOption;
          } else if (item.id == "diskReadAndWriteBPS") {
            var optionFll = this.diskReadAndWriteBPSOption;
          } else if (item.id == "diskReadAndWriteRequestCount") {
            var optionFll = this.diskReadAndWriteRequestCountOption;
          }
          // aws
          else if (item.id == "volumeTotalReadWriteTimes") {
            var optionFll = this.volumeTotalReadWriteTimesOption;
          } else if (item.id == "volumeReadWriteOps") {
            var optionFll = this.volumeReadWriteOpsOption;
          } else if (item.id == "volumeReadWriteBytes") {
            var optionFll = this.volumeReadWriteBytesOption;
          } else if (item.id == "burstBalances") {
            var optionFll = this.burstBalancesOption;
          } else if (item.id == "volumeQueueLengths") {
            var optionFll = this.volumeQueueLengthsOption;
          } else if (item.id == "volumeIdleTimes") {
            var optionFll = this.volumeIdleTimesOption;
          }
          //gcp
          else if (item.id == "chartElementGcpDiskBytesUsed") {
            var optionFll = this.gcpDiskBytesUsedOption;
          }else if (item.id == "chartElementGcpDiskIOTime") {
            var optionFll = this.gcpDiskIOTimeOption;
          }else if (item.id == "chartElementGcpDiskOperationCount") {
            var optionFll = this.gcpDiskOperationCountOption;
          }

          fullChart.setOption(optionFll);
          window.addEventListener("resize", function () {
            fullChart.resize();
          });
        }
      });
    },
    // 模态框取消事件
    cancel() {
      this.isShowModal = false;
    },
    /******************查询********************************/
    // 查询时间范围
    queryTimeHorizon: function () {
      this.$api.cloudWatch
        .queryTimeHorizon("userName", getCookie(global.cookieName))
        .then((res) => {
          this.timeList = res.data;
        });
    },
    // 腾讯云专用时间范围
    queryTencentTimeHorizon: function () {
      this.$api.tencentMonitor.queryTimeHorizon().then((res) => {
        this.timeList = res.data;
        if (res.data && res.data.length > 0) {
          this.timeType = res.data[0].id;
        }
        this.checkTencentCbsStatistics();
      });
      this.cycleList = [
        { name: "1分钟", value: 60 },
        { name: "5分钟", value: 300 },
        { name: "1小时", value: 3600 },
      ];
    },
    // AWS折线图
    checkMonitorModuleIndex: function () {
      this.$api.cloudWatch
        .checkMonitorModuleIndex({
          accountId: this.$route.query.accountId,
          timeHorizon: this.timeType,
          period: this.cycle,
          monitorModule: 11,
          instanceId: this.$route.query.volumeAwsId,
          region: this.$route.query.region,
        })
        .then((res) => {
          this.diskReadOps = res.data.diskReadOps;
          this.diskWriteOps = res.data.diskWriteOps;
          this.burstBalance = res.data.burstBalance;
          this.volumeIdleTime = res.data.volumeIdleTime;
          this.volumeQueueLength = res.data.volumeQueueLength;
          this.diskReadBytes = res.data.diskReadBytes;
          this.volumeTotalReadTime = res.data.volumeTotalReadTime;
          this.volumeTotalWriteTime = res.data.volumeTotalWriteTime;
          this.diskWriteBytes = res.data.diskWriteBytes;
          this.xaxisDataAWS = res.data.xaxisData;
          this.allAWS();
        });
    },
    // Azure折线图
    checkAzureCloudVMDiskStatistics: function () {
      this.$api.cloudWatch
        .checkAzureCloudVMDiskStatistics({
          accountId: this.$route.query.accountId,
          timeHorizon: this.timeType,
          monitorModule: 11,
          instanceId: this.$route.query.volumeAwsId,
          region: this.$route.query.region,
        })
        .then((res) => {
          this.diskWriteIOPSAzure = res.data.diskWriteIOPS;
          this.diskReadIOPSAzure = res.data.diskReadIOPS;
          this.xaxisData = res.data.xaxisData;
          this.initAzure();
        });
    },
    // Aliyun折线图
    checkAliyunDiskStatistics: function () {
      this.$api.cloudWatch
        .checkAliyunDiskStatistics({
          accountId: this.$route.query.accountId,
          timeHorizon: this.timeType,
          monitorModule: 11,
          instanceId: this.$route.query.instanceId,
          region: this.$route.query.region,
        })
        .then((res) => {
          this.diskSpaceUtilizationAliyun = res.data.diskSpaceUtilization;
          this.diskReadIOPSAliyun = res.data.readIOPSUsage;
          this.diskWriteIOPSAliyun = res.data.writeIOPSUsage;
          this.spaceUsageAliyun = res.data.spaceUsage;
          this.inodeUtilizationAliyun = res.data.inodeUtilization;
          this.diskReadAndWriteBPSAliyun = res.data.diskReadAndWriteBPS;
          this.diskReadBPS = res.data.diskReadBPS;
          this.diskWriteBPS = res.data.diskWriteBPS;
          this.diskReadAndWriteRequestCountAliyun =
            res.data.diskReadAndWriteRequestCount;
          this.diskReadRequestCount = res.data.diskReadRequestCount;
          this.diskWriteRequestCount = res.data.diskWriteRequestCount;
          this.xaxisData = res.data.xaxisData;
          this.initAliyun();
        });
    },
    // Gcp折线图
    checkGCPDiskStatistics: function () {
      this.$api.cloudWatch
        .checkGCPDiskStatistics({
          accountId: this.$route.query.accountId,
          timeHorizon: this.timeType,
          monitorModule: 11,
          instanceId: this.$route.query.instanceId,
          region: this.$route.query.region,
        })
        .then((res) => {
          this.gcpDiskBytesUsed = res.data.diskBytesUsed;
          this.gcpDiskIOTime = res.data.diskIOTime;
          this.gcpDiskOperationCount = res.data.diskOperationCount;
          this.gcpXaxisDataTimeLine = res.data.xaxisData;
          this.initGcp();
        });
    },
    // 切换时间
    changeTimeType: function () {
      this.checkAzureCloudVMDiskStatistics();
    },
    // 切换时间
    changeTimeTypeAWS: function () {
      this.checkMonitorModuleIndex();
    },
    // 切换周期
    changeCycle: function () {
      this.checkMonitorModuleIndex();
    },
    // 切换时间
    changeTimeTypeAliyun: function () {
      this.checkAliyunDiskStatistics();
    },
    // 切换时间
    changeTimeTypeGCP: function(){
      this.checkGCPDiskStatistics();
    },
    // 腾讯云切换时间
    changeTimeTypeTencent: function () {
      this.checkTencentCbsStatistics();
    },
    // 腾讯云切换周期
    changeCycleTencent: function () {
      this.checkTencentCbsStatistics();
    },
    // 腾讯云CBS折线图
    checkTencentCbsStatistics: function () {
      this.$api.tencentMonitor
        .queryCbsMonitor({
          accountId: this.$route.query.accountId,
          resourceId: this.$route.query.volumeAwsId,
          region: this.$route.query.region,
          timeRange: this.timeType,
          period: this.cycle || 60,
        })
        .then((res) => {
          if (res.data && res.data.metrics) {
            this.renderTencentCharts(res.data.metrics);
          }
        });
    },
    // 腾讯云渲染图表
    renderTencentCharts: function (metrics) {
      const chartIdMap = {
        DiskReadIops: "tencentDiskReadIops",
        DiskWriteIops: "tencentDiskWriteIops",
      };
      this.tencentChartInstances = [];
      metrics.forEach((metric) => {
        const chartId = chartIdMap[metric.metricName];
        if (!chartId) return;
        const el = this.$refs[chartId];
        if (!el || !el[0]) return;
        const chart = this.$echarts.init(el[0]);
        chart.setOption({
          tooltip: { trigger: "axis" },
          xAxis: {
            type: "category",
            data: metric.timestamps,
            axisLabel: {
              formatter: function (val) {
                return val ? val.substring(11, 16) : "";
              },
            },
          },
          yAxis: { type: "value", name: metric.unit || "" },
          series: [
            {
              name: metric.metricLabel || metric.metricName,
              type: "line",
              smooth: true,
              data: metric.values,
              areaStyle: { opacity: 0.15 },
            },
          ],
        });
        this.tencentChartInstances.push(chart);
      });
      if (!this._tencentResizeHandler) {
        this._tencentResizeHandler = () => {
          this.tencentChartInstances.forEach(c => c.resize());
        };
        window.addEventListener("resize", this._tencentResizeHandler);
      }
    },
    /******************所有折线图********************************/
    initAzure: function () {
      this.diskReadWriteIOPSLine();
    },
    initAliyun: function () {
      this.diskReadIOPSLine();
      this.diskWriteIOPSLine();
      this.diskSpaceUtilizationLine();
      this.spaceUsageLine();
      this.inodeUtilizationLine();
      this.diskReadAndWriteBPSLine();
      this.diskReadAndWriteRequestCountLine();
    },
    allAWS: function () {
      this.chartVolumeTotalReadWriteTimesLine();
      this.chartVolumeReadWriteOpsLine();
      this.chartVolumeReadWriteBytesLine();
      this.chartBurstBalancesLine();
      this.chartVolumeQueueLengthsLine();
      this.chartVolumeIdleTimesLine();
    },
    initGcp: function () {
      this.gcpDiskBytesUsedEchartsLine();
      this.gcpDiskIOTimeEchartsLine();
      this.gcpDiskOperationCountEchartsLine();
    },
    /******************Azure折线图********************************/
    // 磁盘读写IOPS(IOPS)
    diskReadWriteIOPSLine: function () {
      this.chartDiskReadWriteIOPS = this.$echarts.init(
        document.getElementById("diskReadWriteIOPS")
      );
      this.diskReadWriteIOPSOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        // 磁盘读IOPS 磁盘写IOPS
        legend: {
          x: "right",
          y: "10px",
          data: [
            this.$t("alarms.disk.line.DiskReadIOPS"),
            this.$t("alarms.disk.line.DiskWriteIOPS"),
          ],
        },
        series: [
          {
            name: this.$t("alarms.disk.line.DiskReadIOPS"),
            type: "line",
            data: this.diskReadIOPSAzure,
            itemStyle: {
              normal: {
                color: "#803500",
                lineStyle: {
                  color: "#803500",
                },
              },
            },
          },
          {
            name: this.$t("alarms.disk.line.DiskWriteIOPS"),
            type: "line",
            data: this.diskWriteIOPSAzure,
            itemStyle: {
              normal: {
                color: "#FF9B40",
                lineStyle: {
                  color: "#FF9B40",
                },
              },
            },
          },
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartDiskReadWriteIOPS.setOption(this.diskReadWriteIOPSOption);
    },
    /******************Aliyun折线图********************************/
    // 磁盘读IOPS(IOPS)
    diskReadIOPSLine: function () {
      this.chartDiskReadIOPS = this.$echarts.init(
        document.getElementById("diskReadIOPS")
      );
      this.diskReadIOPSOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        // 磁盘读IOPS
        legend: {
          x: "right",
          y: "10px",
          data: [this.$t("alarms.disk.line.DiskReadIOPS")],
        },
        series: [
          {
            name: this.$t("alarms.disk.line.DiskReadIOPS"),
            type: "line",
            data: this.diskReadIOPSAliyun,
            itemStyle: {
              normal: {
                color: "#803500",
                lineStyle: {
                  color: "#803500",
                },
              },
            },
          },
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartDiskReadIOPS.setOption(this.diskReadIOPSOption);
    },
    // 磁盘写IOPS(IOPS)
    diskWriteIOPSLine: function () {
      this.chartDiskWriteIOPS = this.$echarts.init(
        document.getElementById("diskWriteIOPS")
      );
      this.diskWriteIOPSOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        // 磁盘写IOPS
        legend: {
          x: "right",
          y: "10px",
          data: [this.$t("alarms.disk.line.DiskWriteIOPS")],
        },
        series: [
          {
            name: this.$t("alarms.disk.line.DiskWriteIOPS"),
            type: "line",
            data: this.diskWriteIOPSAliyun,
            itemStyle: {
              normal: {
                color: "#803500",
                lineStyle: {
                  color: "#803500",
                },
              },
            },
          },
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartDiskWriteIOPS.setOption(this.diskWriteIOPSOption);
    },
    // 磁盘空间使用率
    diskSpaceUtilizationLine: function () {
      this.chartDiskSpaceUtilization = this.$echarts.init(
        document.getElementById("diskSpaceUtilization")
      );
      this.diskSpaceUtilizationOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        // 磁盘空间使用率
        legend: {
          x: "right",
          y: "10px",
          data: [this.$t("alarms.disk.line.DiskSpaceUsage")],
        },
        series: [
          {
            name: this.$t("alarms.disk.line.DiskSpaceUsage"),
            type: "line",
            data: this.diskSpaceUtilizationAliyun,
            itemStyle: {
              normal: {
                color: "#803500",
                lineStyle: {
                  color: "#803500",
                },
              },
            },
          },
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartDiskSpaceUtilization.setOption(this.diskSpaceUtilizationOption);
    },
    // 磁盘空间使用量
    spaceUsageLine: function () {
      this.chartSpaceUsage = this.$echarts.init(
        document.getElementById("spaceUsage")
      );
      this.spaceUsageOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        // 磁盘空间使用量
        legend: {
          x: "right",
          y: "10px",
          data: [this.$t("alarms.disk.line.SpaceUsage")],
        },
        series: [
          {
            name: this.$t("alarms.disk.line.SpaceUsage"),
            type: "line",
            data: this.spaceUsageAliyun,
            itemStyle: {
              normal: {
                color: "#803500",
                lineStyle: {
                  color: "#803500",
                },
              },
            },
          },
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartSpaceUsage.setOption(this.spaceUsageOption);
    },

    // Inode使用率（%）
    inodeUtilizationLine: function () {
      this.chartInodeUtilization = this.$echarts.init(
        document.getElementById("inodeUtilization")
      );
      this.inodeUtilizationOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        // Inode使用率（%）
        legend: {
          x: "right",
          y: "10px",
          data: [this.$t("alarms.disk.line.InodeUtilization")],
        },
        series: [
          {
            name: this.$t("alarms.disk.line.InodeUtilization"),
            type: "line",
            data: this.inodeUtilizationAliyun,
            itemStyle: {
              normal: {
                color: "#803500",
                lineStyle: {
                  color: "#803500",
                },
              },
            },
          },
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartInodeUtilization.setOption(this.inodeUtilizationOption);
    },
    //磁盘读写字节数（bytes/s）
    diskReadAndWriteBPSLine: function () {
      this.chartDiskReadAndWriteBPS = this.$echarts.init(
        document.getElementById("diskReadAndWriteBPS")
      );
      this.diskReadAndWriteBPSOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        // 磁盘读写字节数（bytes/s）
        legend: {
          x: "right",
          y: "10px",
          data: [
            this.$t("alarms.disk.line.DiskReadBPS"),
            this.$t("alarms.disk.line.DiskWriteBPS"),
          ],
        },
        series: [
          {
            name: this.$t("alarms.disk.line.DiskReadBPS"),
            type: "line",
            data: this.diskReadBPS,
            itemStyle: {
              normal: {
                color: "#803500",
                lineStyle: {
                  color: "#803500",
                },
              },
            },
          },
          {
            name: this.$t("alarms.disk.line.DiskWriteBPS"),
            type: "line",
            data: this.diskWriteBPS,
            itemStyle: {
              normal: {
                color: "#c23531",
                lineStyle: {
                  color: "#c23531",
                },
              },
            },
          },
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartDiskReadAndWriteBPS.setOption(this.diskReadAndWriteBPSOption);
    },
    //磁盘读写请求数（count/s）
    diskReadAndWriteRequestCountLine: function () {
      this.chartDiskReadAndWriteRequestCount = this.$echarts.init(
        document.getElementById("diskReadAndWriteRequestCount")
      );
      this.diskReadAndWriteRequestCountOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        // 磁盘读写请求数（count/s）
        legend: {
          x: "right",
          y: "10px",
          data: [
            this.$t("alarms.disk.line.DiskReadRequestCount"),
            this.$t("alarms.disk.line.DiskWriteRequestCount"),
          ],
        },
        series: [
          {
            name: this.$t("alarms.disk.line.DiskReadRequestCount"),
            type: "line",
            data: this.diskReadRequestCount,
            itemStyle: {
              normal: {
                color: "#803500",
                lineStyle: {
                  color: "#803500",
                },
              },
            },
          },
          {
            name: this.$t("alarms.disk.line.DiskWriteRequestCount"),
            type: "line",
            data: this.diskWriteRequestCount,
            itemStyle: {
              normal: {
                color: "#c23531",
                lineStyle: {
                  color: "#c23531",
                },
              },
            },
          },
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartDiskReadAndWriteRequestCount.setOption(
        this.diskReadAndWriteRequestCountOption
      );
    },

    /*************AWS折线图*****************************/
    // 读取和写入操作耗费的总秒数（秒）
    chartVolumeTotalReadWriteTimesLine: function () {
      this.chartVolumeTotalReadWriteTimes = this.$echarts.init(
        document.getElementById("volumeTotalReadWriteTimes")
      );
      this.volumeTotalReadWriteTimesOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        // 读取操作耗费的总秒数 写入操作耗费的总秒数
        legend: {
          x: "right",
          y: "10px",
          data: [
            this.$t(
              "alarms.disk.line.TheTotalNumberOfSecondsSpentInTheReadOperation"
            ),
            this.$t(
              "alarms.disk.line.TheTotalNumberOfSecondsSpentInWriteOperations"
            ),
          ],
        },
        series: [
          {
            name: this.$t(
              "alarms.disk.line.TheTotalNumberOfSecondsSpentInTheReadOperation"
            ),
            type: "line",
            data: this.volumeTotalReadTime,
            itemStyle: {
              normal: {
                color: "#61a0a8",
                lineStyle: {
                  color: "#61a0a8",
                },
              },
            },
          },
          {
            name: this.$t(
              "alarms.disk.line.TheTotalNumberOfSecondsSpentInWriteOperations"
            ),
            type: "line",
            data: this.volumeTotalWriteTime,
            itemStyle: {
              normal: {
                color: "#FF9B40",
                lineStyle: {
                  color: "#FF9B40",
                },
              },
            },
          },
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisDataAWS.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartVolumeTotalReadWriteTimes.setOption(
        this.volumeTotalReadWriteTimesOption
      );
    },
    // 读写吞吐量（Ops/s）
    chartVolumeReadWriteOpsLine: function () {
      this.chartVolumeReadWriteOps = this.$echarts.init(
        document.getElementById("volumeReadWriteOps")
      );
      this.volumeReadWriteOpsOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        // 读取吞吐量 写入吞吐量
        legend: {
          x: "right",
          y: "10px",
          data: [
            this.$t("alarms.disk.line.ReadThroughput"),
            this.$t("alarms.disk.line.WriteThroughput"),
          ],
        },
        series: [
          {
            name: this.$t("alarms.disk.line.ReadThroughput"),
            type: "line",
            data: this.diskReadOps,
            itemStyle: {
              normal: {
                color: "#c23531",
                lineStyle: {
                  color: "#c23531",
                },
              },
            },
          },
          {
            name: this.$t("alarms.disk.line.WriteThroughput"),
            type: "line",
            data: this.diskWriteOps,
            itemStyle: {
              normal: {
                color: "#2f4554",
                lineStyle: {
                  color: "#2f4554",
                },
              },
            },
          },
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisDataAWS.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartVolumeReadWriteOps.setOption(this.volumeReadWriteOpsOption);
    },
    // 读写宽带（字节）
    chartVolumeReadWriteBytesLine: function () {
      this.chartVolumeReadWriteBytes = this.$echarts.init(
        document.getElementById("volumeReadWriteBytes")
      );
      this.volumeReadWriteBytesOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        // 读取带宽 写入带宽
        legend: {
          x: "right",
          y: "10px",
          data: [
            this.$t("alarms.disk.line.ReadBandwidth"),
            this.$t("alarms.disk.line.WriteBandwidth"),
          ],
        },
        series: [
          {
            name: this.$t("alarms.disk.line.ReadBandwidth"),
            type: "line",
            data: this.diskReadBytes,
            itemStyle: {
              normal: {
                color: "#ccc",
                lineStyle: {
                  color: "#ccc",
                },
              },
            },
          },
          {
            name: this.$t("alarms.disk.line.WriteBandwidth"),
            type: "line",
            data: this.diskWriteBytes,
            itemStyle: {
              normal: {
                color: "#4671D5",
                lineStyle: {
                  color: "#4671D5",
                },
              },
            },
          },
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisDataAWS.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartVolumeReadWriteBytes.setOption(this.volumeReadWriteBytesOption);
    },
    // 突发余额（百分比）
    chartBurstBalancesLine: function () {
      this.chartBurstBalances = this.$echarts.init(
        document.getElementById("burstBalances")
      );
      this.burstBalancesOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        // 突发余额
        legend: {
          x: "right",
          y: "10px",
          data: [this.$t("alarms.disk.line.BurstBalance")],
        },
        series: [
          {
            name: this.$t("alarms.disk.line.BurstBalance"),
            type: "line",
            data: this.burstBalance,
            itemStyle: {
              normal: {
                color: "#91c7ae",
                lineStyle: {
                  color: "#91c7ae",
                },
              },
            },
          },
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisDataAWS.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartBurstBalances.setOption(this.burstBalancesOption);
    },
    //平均队列长度（秒）
    chartVolumeQueueLengthsLine: function () {
      this.chartVolumeQueueLengths = this.$echarts.init(
        document.getElementById("volumeQueueLengths")
      );
      this.volumeQueueLengthsOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        // 平均队列长度
        legend: {
          x: "right",
          y: "10px",
          data: [this.$t("alarms.disk.line.AverageQueueLength")],
        },
        series: [
          {
            name: this.$t("alarms.disk.line.AverageQueueLength"),
            type: "line",
            data: this.volumeQueueLength,
            itemStyle: {
              normal: {
                color: "#ceca58",
                lineStyle: {
                  color: "#ceca58",
                },
              },
            },
          },
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisDataAWS.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartVolumeQueueLengths.setOption(this.volumeQueueLengthsOption);
    },
    // 空闲花费时间百分比（秒）
    chartVolumeIdleTimesLine: function () {
      this.chartVolumeIdleTimes = this.$echarts.init(
        document.getElementById("volumeIdleTimes")
      );
      this.volumeIdleTimesOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        // 空闲花费时间百分比
        legend: {
          x: "right",
          y: "10px",
          data: [this.$t("alarms.disk.line.PercentageOfIdleTime")],
        },
        series: [
          {
            name: this.$t("alarms.disk.line.PercentageOfIdleTime"),
            type: "line",
            data: this.volumeIdleTime,
            itemStyle: {
              normal: {
                color: "#c4aaaa",
                lineStyle: {
                  color: "#c4aaaa",
                },
              },
            },
          },
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisDataAWS.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartVolumeIdleTimes.setOption(this.volumeIdleTimesOption);
    },

    // （Agent）已使用的磁盘字节数 (bytes_used)
    gcpDiskBytesUsedEchartsLine: function () {
      this.chartGcpDiskBytesUsed = this.$echarts.init(
        document.getElementById("chartElementGcpDiskBytesUsed")
      );

      var customSeries = [];
      var customLegend = {x: "right",y: "10px", data:[]};
      for (var i = 0; i < this.gcpDiskBytesUsed.length; i++){
        var seriesA = {};
        seriesA.name = this.gcpDiskBytesUsed[i].name;
        seriesA.type = "line";
        seriesA.itemStyle = {
          normal: { color: "#c4aaaa", lineStyle: { color: "#c4aaaa" } },
        };
        seriesA.data = this.gcpDiskBytesUsed[i].pointData;
        customSeries.push(seriesA);
        if(customLegend.data.length < 4) {
          customLegend.data.push(this.gcpDiskBytesUsed[i].name)
        }
      }

      this.gcpDiskBytesUsedOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        legend: customLegend,
        series: customSeries,
        grid: {top: "35%",left: "3%",bottom: "3%",containLabel: true},
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.gcpXaxisDataTimeLine.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartGcpDiskBytesUsed.setOption(this.gcpDiskBytesUsedOption);
    },

    gcpDiskIOTimeEchartsLine: function () {
      this.chartGcpDiskIOTime = this.$echarts.init(
        document.getElementById("chartElementGcpDiskIOTime")
      );

      var customSeries = [];
      var customLegend = {x: "right",y: "10px", data:[]};
      for (var i = 0; i < this.gcpDiskIOTime.length; i++){
        var seriesA = {};
        seriesA.name = this.gcpDiskIOTime[i].name;
        seriesA.type = "line";
        seriesA.itemStyle = {
          normal: { color: "#c4aaaa", lineStyle: { color: "#c4aaaa" } },
        };
        seriesA.data = this.gcpDiskIOTime[i].pointData;
        customSeries.push(seriesA);
        customLegend.data.push(this.gcpDiskIOTime[i].name)
      }

      this.gcpDiskIOTimeOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        legend: customLegend,
        series: customSeries,
        grid: {top: "35%",left: "3%",bottom: "3%",containLabel: true},
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.gcpXaxisDataTimeLine.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartGcpDiskIOTime.setOption(this.gcpDiskIOTimeOption);
    },

    gcpDiskOperationCountEchartsLine: function () {
      this.chartGcpDiskOperationCount = this.$echarts.init(
        document.getElementById("chartElementGcpDiskOperationCount")
      );

      var customSeries = [];
      var customLegend = {x: "right",y: "10px", data:[]};
      for (var i = 0; i < this.gcpDiskOperationCount.length; i++){
        var seriesA = {};
        seriesA.name = this.gcpDiskOperationCount[i].name;
        seriesA.type = "line";
        seriesA.itemStyle = {
          normal: { color: "#c4aaaa", lineStyle: { color: "#c4aaaa" } },
        };
        seriesA.data = this.gcpDiskOperationCount[i].pointData;
        customSeries.push(seriesA);
        if(customLegend.data.length < 6){
          customLegend.data.push(this.gcpDiskOperationCount[i].name)
        }
      }

      this.gcpDiskOperationCountOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        legend: customLegend,
        series: customSeries,
        grid: {top: "35%",left: "3%",bottom: "3%",containLabel: true},
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.gcpXaxisDataTimeLine.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartGcpDiskOperationCount.setOption(this.gcpDiskOperationCountOption);
    },

    /******************************/
    // 点击返回详情页
    ipAddress: function () {
      this.id = this.$route.query.id;
      this.accountId = this.$route.query.accountId;
      this.volumeAwsId = this.$route.query.volumeAwsId;
      this.region = this.$route.query.region;
      this.accountTypeName = this.$route.query.accountTypeName;
      this.accountName = this.$route.query.accountName;
      this.name = this.$route.query.name;
      this.$router.push({
        path: "/monitor/elasticBlockStoreDetail/",
        query: {
          id: this.id,
          accountId: this.accountId,
          volumeAwsId: this.volumeAwsId,
          region: this.region,
          accountTypeName: this.accountTypeName,
          accountName: this.accountName,
          name: this.name,
        },
      });
    },
  },
  beforeDestroy() {
    if (this._tencentResizeHandler) {
      window.removeEventListener("resize", this._tencentResizeHandler);
    }
  },
};
</script>

<style scoped>
.ebs-title {
  width: 100%;
  font-size: 13px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 15px 0px 15px 4px;
  font-weight: 600;
}

.ivu-col-span-12 {
  margin-bottom: 20px;
}

.ivu-col-span-6 {
  margin-bottom: 20px;
}

.ebs-top {
  width: 100%;
  height: 53px;
}

.ivu-breadcrumb {
  font-size: 13px;
  font-weight: 600;
  color: #515a6e;
}
</style>





// WEBPACK FOOTER //
// src/components/monitor/ebs/ebs_dashboard/EBS.vue